"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Label_1 = __importDefault(require("components/shared/Label/Label"));
const LoadingComponent = ({ size = 24, text = 'Loading', hasText = true, className, textClass = 'loading-text', labelClass, children }) => {
    const LoadingComponentCN = (0, classnames_template_literals_1.default)(`flex
    items-center
    justify-center
    ${className}`);
    return (react_1.default.createElement("div", { className: LoadingComponentCN },
        react_1.default.createElement("div", { className: "lds-ring relative inline-block", style: { width: size + 'px', height: size + 'px' } },
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } })),
        text && hasText && (react_1.default.createElement("div", { className: textClass },
            react_1.default.createElement(Label_1.default, { className: labelClass }, text))),
        children && children));
};
exports.default = LoadingComponent;
